export default "__VITE_ASSET__Cp0CdRnV__"